import * as configUtils from "util/config";

export const debinTitles = ["debin.main.title"];
export const debinTabTitles = ["debin.recived", "debin.generated", "debin.recurrences"];
export const debinOptions = ["received.debin", "recurrent.debin", "emited.debin"];
export const documentTypeFormats = (documentType, document) => {
    const isnum = /^\d+$/.test(document);
    if (documentType === "DNI") {
        if (document.length < 6 || document.length > 8 || !isnum) {
            return false;
        }
    }

    if (documentType === "CUIT" || documentType === "CUIL" || documentType === "CDI") {
        if (document.length !== 11 || !isnum) {
            return false;
        }
    }
    return true;
};

export const debinStatusActions = {
    INICIADO: ["PAY"],
};

export const statusTagColor = (state) => {
    switch (state) {
        case "ACTIVA":
            return "success";
        case "ACTIVO":
            return "success";
        case "Activo":
            return "success";
        case "INACTIVA":
            return "warning";
        case "INACTIVA DEFINITIVA":
            return "error";
        case "INICIADO":
            return "warning";
        case "ELIMINADO":
            return "error";
        case "Rechazado":
            return "error";
        case "Inactivo":
            return "info";
        case "Finalizado":
            return "finished";
        default:
            return "warning";
    }
};
export const states = configUtils.getArray("debin.states", ["TODOS", "ACTIVO", "PAUSADO", "ELIMINADO"]);
export const statesRecived = configUtils.getArray("debin.states", [
    "Todos",
    "ELIMINADO",
    "ACREDITADO",
    "INICIADO",
    "VENCIDO",
    "RECHAZO DE CLIENTE",
    "SIN GARANTIA",
    "SIN SALDO",
    "ERROR",
    "ERROR DEBITO",
    "ERROR ACREDITACION",
    "ERROR DATOS",
]);

export const scheduledStatesRecived = configUtils.getArray("scheduledDebin.states", [
    "TODOS",
    "ACTIVO",
    "INACTIVO",
    "PENDIENTE",
    "RECHAZADO",
    "FINALIZADO",
]);

export const getDebinTypes = (environmentType) =>
    configUtils.getArray(`debin.${environmentType}.types`, ["TODOS", "DEBIN", "CONTRACARGO"]);
